(function () {
  const FEE_HANDLE = 'personalisation-fee';
  const PROP_FEE_FLAG = '_MSH_PersoFee';
  const PROP_FEE_CENTS = '_MSH_PersoFeeCents';
  const PROP_FEE_HANDLE = '_MSH_PersoFeeHandle';
  const PROP_FEE_FOR = '_MSH_PersoFeeFor';
  const PROP_FEE_PARENT = '_MSH_PersoFeeParentKey';
  const PROP_FEE_PARENT_LEGACY = '_MSH_PersoFeeParent';
  const PROP_NONCE = '_MSH_PersoNonce';

  const DEBUG = new URLSearchParams(window.location.search).get('mshdebug') === '1';

  window.MSH_PersoFeeSync = window.MSH_PersoFeeSync || {};

  let feeVariantMapPromise;
  let checkoutSyncInProgress = false;
  let syncTriggerArmed = false;
  let syncTriggeredByCartMutation = false;

  function log() {
    if (!DEBUG) return;
    console.log('[msh-perso-fee-sync]', ...arguments);
  }

  function toInt(value) {
    const parsed = parseInt(String(value || '0'), 10);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function hasValidPersonalisation(properties) {
    const source = properties || {};
    const feeFor = String(source[PROP_FEE_FOR] || source['Printed initials'] || source['Printed initials:'] || source.Initials || '').trim();
    return feeFor.length > 0;
  }

  function getFeeParentKey(properties) {
    const source = properties || {};
    return String(source[PROP_FEE_PARENT] || source[PROP_FEE_PARENT_LEGACY] || '').trim();
  }

  function isCartPage() {
    return Boolean(
      document.querySelector('cart-items') ||
        document.querySelector('#shopify-section-main-cart-items')
    );
  }

  function isMainCartPage() {
    return Boolean(document.querySelector('cart-items')) && window.location.pathname.indexOf('/cart') !== -1;
  }

  function getVisibleCount(cart) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    return items.reduce((count, item) => {
      const properties = item.properties || {};
      if (properties[PROP_FEE_FLAG] === 'true') return count;
      return count + toInt(item.quantity);
    }, 0);
  }

  function updateVisibleCartCount(cart) {
    try {
      const visibleCount = getVisibleCount(cart);
      const countSelectors = [
        '[data-cart-count]',
        '.cart-count-bubble span',
        '.header__icon--cart .cart-count-bubble span',
      ];
      const countNodes = document.querySelectorAll(countSelectors.join(', '));
      countNodes.forEach((node) => {
        node.textContent = String(visibleCount);
      });

      const drawerCountNodes = document.querySelectorAll('.drawer__heading .h2, .drawer__heading, .cart-drawer__heading');
      drawerCountNodes.forEach((node) => {
        if (!node || !node.childNodes) return;
        node.childNodes.forEach((child) => {
          if (child.nodeType !== Node.TEXT_NODE) return;
          if (!/\d/.test(child.textContent || '')) return;
          child.textContent = child.textContent.replace(/\d+/, String(visibleCount));
        });
      });

      log('visible cart count updated', visibleCount);
    } catch (error) {
      log('visible cart count update failed', error);
    }
  }

  async function getCart() {
    const response = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await response.json();
    updateVisibleCartCount(cart);
    return cart;
  }

  async function getFeeVariantIdByCents(cents) {
    if (!feeVariantMapPromise) {
      feeVariantMapPromise = fetch(`/products/${FEE_HANDLE}.js`, { credentials: 'same-origin' })
        .then((response) => response.json())
        .then((product) => {
          const variantMap = new Map();
          (product.variants || []).forEach((variant) => {
            if (typeof variant.price === 'number') {
              variantMap.set(variant.price, variant.id);
            }
          });
          return variantMap;
        })
        .catch((error) => {
          feeVariantMapPromise = null;
          throw error;
        });
    }

    const variantMap = await feeVariantMapPromise;
    return variantMap.get(cents) || null;
  }

  async function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    });
  }

  async function postForm(url, dataObj) {
    const body = new URLSearchParams();
    Object.entries(dataObj || {}).forEach(([k, v]) => {
      if (v === undefined || v === null) return;
      body.append(k, String(v));
    });

    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body,
    });
  }

  async function cartChangeLineWithProperties(line, quantity, properties) {
    const body = new URLSearchParams();
    body.append('line', String(line));
    body.append('quantity', String(quantity));

    const props = properties || {};
    Object.keys(props).forEach((key) => {
      body.append(`properties[${key}]`, String(props[key]));
    });

    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body,
    });
  }

  async function forceCartSectionsRerender(reason) {
    const mainSection = document.querySelector('#shopify-section-main-cart-items');
    const footerSection = document.querySelector('#shopify-section-main-cart-footer');

    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { reason } }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { reason } }));

    if (window.PUB_SUB_EVENTS && window.publish) {
      try {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'msh-perso-fee-sync', reason });
      } catch (error) {
        log('pubsub cartUpdate publish failed', error);
      }
    }

    if (!mainSection || !footerSection) return;

    try {
      const response = await fetch(`${window.location.pathname}?sections=main-cart-items,main-cart-footer`, {
        credentials: 'same-origin',
      });
      if (!response.ok) return;

      const sections = await response.json();
      if (typeof sections['main-cart-items'] === 'string') {
        mainSection.innerHTML = sections['main-cart-items'];
      }
      if (typeof sections['main-cart-footer'] === 'string') {
        footerSection.innerHTML = sections['main-cart-footer'];
      }
    } catch (error) {
      log('forceCartSectionsRerender failed', error);
    }
  }

  async function forceDrawerSectionsRerender(reason) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;

    try {
      const [drawerResponse, bubbleResponse] = await Promise.all([
        fetch('/cart?section_id=cart-drawer', { credentials: 'same-origin' }),
        fetch('/cart?section_id=cart-icon-bubble', { credentials: 'same-origin' }),
      ]);
      if (!drawerResponse.ok || !bubbleResponse.ok) return;

      const [drawerHtml, bubbleHtml] = await Promise.all([drawerResponse.text(), bubbleResponse.text()]);
      const cartResponse = await getCart();
      cartResponse.sections = {
        ...(cartResponse.sections || {}),
        'cart-drawer': drawerHtml,
        'cart-icon-bubble': bubbleHtml,
      };
      cartDrawer.renderContents(cartResponse);
    } catch (error) {
      log('forceDrawerSectionsRerender failed', reason, error);
    }
  }

  async function refreshCartUiAfterSync(reason, options) {
    const settings = options || {};
    const allowDrawerRerender = settings.allowDrawerRerender === true;

    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { reason } }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { reason } }));

    if (window.PUB_SUB_EVENTS && window.publish) {
      try {
        await window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'msh-perso-fee-sync', reason });
      } catch (error) {
        log('pubsub cartUpdate publish failed', error);
      }
    }

    await Promise.all([
      window.location.pathname.indexOf('/cart') === 0 ? forceCartSectionsRerender(reason) : Promise.resolve(),
      allowDrawerRerender ? forceDrawerSectionsRerender(reason) : Promise.resolve(),
    ]);
  }

  async function normalizeFeeParentKeyByNonce(cart) {
    const sourceCart = cart && Array.isArray(cart.items) ? cart : await getCart();
    const items = Array.isArray(sourceCart.items) ? sourceCart.items : [];

    const mainsByNonce = new Map();
    const feeEntries = [];

    items.forEach((item, index) => {
      const properties = item.properties || {};
      const nonce = String(properties[PROP_NONCE] || '').trim();
      const isFee = properties[PROP_FEE_FLAG] === 'true';
      const line = index + 1;

      if (isFee) {
        if (!nonce) return;
        feeEntries.push({ item, nonce, line });
        return;
      }

      const cents = toInt(properties[PROP_FEE_CENTS]);
      const feeFor = String(properties[PROP_FEE_FOR] || '').trim();
      if (!nonce || cents <= 0 || !feeFor) return;

      mainsByNonce.set(nonce, { item, line });
    });

    let changed = false;

    for (const feeEntry of feeEntries) {
      const mainEntry = mainsByNonce.get(feeEntry.nonce);
      if (!mainEntry) continue;

      const feeItem = feeEntry.item;
      const feeProps = feeItem.properties || {};
      const oldParent = String(feeProps[PROP_FEE_PARENT] || '').trim();
      const desiredParentKey = mainEntry.item.key;

      if (oldParent === desiredParentKey) continue;

      changed = true;
      log('normalize parent by nonce', {
        feeLineNumber: feeEntry.line,
        feeNonce: feeEntry.nonce,
        mainKey: desiredParentKey,
        oldParent,
        newParent: desiredParentKey,
      });

      await cartChangeLineWithProperties(feeEntry.line, toInt(feeItem.quantity), {
        ...feeProps,
        [PROP_FEE_PARENT]: desiredParentKey,
      });
    }

    return changed;
  }

  async function syncFeeQtyToParent(cart) {
    const sourceCart = cart && Array.isArray(cart.items) ? cart : await getCart();
    const items = Array.isArray(sourceCart.items) ? sourceCart.items : [];

    const mainQtyByKey = new Map();
    const feeEntries = [];

    items.forEach((item, index) => {
      const properties = item.properties || {};
      const line = index + 1;

      if (properties[PROP_FEE_FLAG] === 'true') {
        feeEntries.push({ item, line });
        return;
      }

      mainQtyByKey.set(item.key, toInt(item.quantity));
    });

    let changed = false;

    for (const feeEntry of feeEntries) {
      const feeItem = feeEntry.item;
      const properties = feeItem.properties || {};
      const parentKey = String(properties[PROP_FEE_PARENT] || '').trim();
      const oldQty = toInt(feeItem.quantity);
      const desiredQty = mainQtyByKey.get(parentKey) || 0;

      if (oldQty === desiredQty) continue;

      changed = true;
      log('sync fee qty to parent', {
        feeLineNumber: feeEntry.line,
        feeNonce: String(properties[PROP_NONCE] || '').trim(),
        mainKey: parentKey,
        oldQty,
        newQty: desiredQty,
      });

      await postForm('/cart/change.js', { line: feeEntry.line, quantity: desiredQty });
    }

    return changed;
  }

  async function removeDuplicateFeeLinesByParent(cart) {
    const sourceCart = cart && Array.isArray(cart.items) ? cart : await getCart();
    const items = Array.isArray(sourceCart.items) ? sourceCart.items : [];
    const feesByParent = new Map();

    items.forEach((item) => {
      const properties = item.properties || {};
      if (properties[PROP_FEE_FLAG] !== 'true') return;
      const parentKey = String(properties[PROP_FEE_PARENT] || '').trim();
      const bucket = feesByParent.get(parentKey) || [];
      bucket.push(item);
      feesByParent.set(parentKey, bucket);
    });

    let changed = false;

    for (const feeItems of feesByParent.values()) {
      if (feeItems.length <= 1) continue;
      for (const feeItem of feeItems.slice(1)) {
        changed = true;
        await postJSON('/cart/change.js', { id: feeItem.key, quantity: 0 });
      }
    }

    return changed;
  }

  async function syncFeeQuantitiesOnly(cart) {
    if (window.__MSH_FEE_QTY_SYNCING) return false;

    window.__MSH_FEE_QTY_SYNCING = true;

    try {
      return await syncFeeQtyToParent(cart);
    } catch (error) {
      log('syncFeeQuantitiesOnly failed', error);
      return false;
    } finally {
      window.__MSH_FEE_QTY_SYNCING = false;
    }
  }

  async function runParentKeyAndQtySync(reason) {
    if (window.__MSH_FEE_SYNC_RUNNING) return false;

    window.__MSH_FEE_SYNC_RUNNING = true;
    try {
      const triggeredByMutation = syncTriggeredByCartMutation;
      syncTriggeredByCartMutation = false;
      let cart = await getCart();
      const parentChanged = await normalizeFeeParentKeyByNonce(cart);
      if (parentChanged) cart = await getCart();

      const qtyChanged = await syncFeeQtyToParent(cart);
      if (qtyChanged) cart = await getCart();

      const duplicateChanged = await removeDuplicateFeeLinesByParent(cart);
      const changed = parentChanged || qtyChanged || duplicateChanged;

      if (changed) {
        await refreshCartUiAfterSync(reason || 'after-parent-qty-sync', {
          allowDrawerRerender: triggeredByMutation,
        });
      }

      return changed;
    } catch (error) {
      log('runParentKeyAndQtySync failed', error);
      return false;
    } finally {
      window.__MSH_FEE_SYNC_RUNNING = false;
    }
  }

  async function syncFeesExact(reason) {
    if (window.__MSH_FEE_SYNC_RUNNING) {
      return false;
    }

    window.__MSH_FEE_SYNC_RUNNING = true;

    try {
      const cart = await getCart();
      const items = Array.isArray(cart.items) ? cart.items : [];

      const mainItems = items.filter((item) => {
        const properties = item.properties || {};
        return properties[PROP_FEE_FLAG] !== 'true';
      });
      const feeItems = items.filter((item) => {
        const properties = item.properties || {};
        return properties[PROP_FEE_FLAG] === 'true';
      });

      const mainKeys = new Set(mainItems.map((item) => item.key));

      const feeItemsByParent = new Map();
      feeItems.forEach((item) => {
        const properties = item.properties || {};
        const parentKey = getFeeParentKey(properties);
        const bucket = feeItemsByParent.get(parentKey) || [];
        bucket.push(item);
        feeItemsByParent.set(parentKey, bucket);
      });

      const actions = [];

      feeItems.forEach((feeItem) => {
        const properties = feeItem.properties || {};
        const parentKey = getFeeParentKey(properties);
        if (!parentKey || !mainKeys.has(parentKey)) {
          actions.push({ type: 'remove', key: feeItem.key, reason: 'orphan-or-missing-parent' });
        }
      });

      for (const mainItem of mainItems) {
        const properties = mainItem.properties || {};
        const parentKey = mainItem.key;
        const cents = toInt(properties[PROP_FEE_CENTS]);
        const feeFor = String(properties[PROP_FEE_FOR] || '').trim();
        const requiresFee = cents > 0 && feeFor.length > 0;
        const existingFees = feeItemsByParent.get(parentKey) || [];

        if (requiresFee) {
          if (existingFees.length === 0) {
            const variantId = await getFeeVariantIdByCents(cents);
            if (!variantId) {
              log('no matching fee variant for cents', cents);
              continue;
            }

            actions.push({
              type: 'add',
              variantId,
              qty: mainItem.quantity,
              parentKey,
              feeFor,
            });
            continue;
          }

          const primary = existingFees[0];
          if (toInt(primary.quantity) !== toInt(mainItem.quantity)) {
            actions.push({ type: 'change', key: primary.key, qty: mainItem.quantity, reason: 'qty-mismatch' });
          }

          existingFees.slice(1).forEach((feeItem) => {
            actions.push({ type: 'remove', key: feeItem.key, reason: 'duplicate' });
          });
          continue;
        }

        existingFees.forEach((feeItem) => {
          actions.push({ type: 'remove', key: feeItem.key, reason: 'no-fee-required' });
        });
      }

      const seenActions = new Set();
      const dedupedActions = actions.filter((action) => {
        const key = `${action.type}:${action.key || action.variantId}:${action.qty || ''}`;
        if (seenActions.has(key)) return false;
        seenActions.add(key);
        return true;
      });

      log('actions', dedupedActions);

      if (!dedupedActions.length) {
        updateVisibleCartCount(cart);
        return false;
      }

      for (const action of dedupedActions) {
        if (action.type === 'add') {
          await postJSON('/cart/add.js', {
            id: action.variantId,
            quantity: action.qty,
            properties: {
              [PROP_FEE_FLAG]: 'true',
              [PROP_FEE_PARENT]: action.parentKey,
              [PROP_FEE_FOR]: action.feeFor,
            },
          });
        } else if (action.type === 'change') {
          await postJSON('/cart/change.js', { id: action.key, quantity: action.qty });
        } else if (action.type === 'remove') {
          await postJSON('/cart/change.js', { id: action.key, quantity: 0 });
        }
      }

      const refreshedCart = await getCart();
      updateVisibleCartCount(refreshedCart);
      await syncFeeQuantitiesOnly(refreshedCart);

      await refreshCartUiAfterSync(reason || 'syncFeesExact', {
        allowDrawerRerender: true,
      });

      return true;
    } catch (error) {
      log('sync failed', error);
      return false;
    } finally {
      window.__MSH_FEE_SYNC_RUNNING = false;
    }
  }

  function triggerSyncDebounced() {
    if (isMainCartPage()) return;
    if (!syncTriggerArmed) return;
    syncTriggerArmed = false;
    if (window.MSH_ScheduleFeeSync) {
      window.MSH_ScheduleFeeSync();
    }
  }

  function getRequestPathname(url) {
    if (!url) return '';
    try {
      return new URL(String(url), window.location.origin).pathname;
    } catch (error) {
      return String(url);
    }
  }

  function isCartMutationRequest(url) {
    const pathname = getRequestPathname(url);
    return (
      pathname.indexOf('/cart/change.js') !== -1 ||
      pathname.indexOf('/cart/update.js') !== -1 ||
      pathname.indexOf('/cart/clear.js') !== -1
    );
  }

  function isCartReadRequest(url) {
    const pathname = getRequestPathname(url);
    return pathname.indexOf('/cart.js') !== -1;
  }

  function patchFetch() {
    if (!window.fetch || window.__MSH_PERSO_FEE_FETCH_PATCHED) return;

    const originalFetch = window.fetch.bind(window);
    window.__MSH_PERSO_FEE_FETCH_PATCHED = true;

    window.fetch = function patchedFetch(input, init) {
      const url = typeof input === 'string' ? input : input && input.url;
      const isCartMutation = isCartMutationRequest(url);
      const isCartRead = isCartReadRequest(url);

      return originalFetch(input, init).then((response) => {
        if (isCartRead) {
          response
            .clone()
            .json()
            .then((cart) => updateVisibleCartCount(cart))
            .catch(() => {});
        }

        if (isCartMutation && response && response.ok && !window.__MSH_FEE_SYNC_INTERNAL && window.MSH_ScheduleFeeSync) {
          syncTriggerArmed = true;
          syncTriggeredByCartMutation = true;
          window.MSH_ScheduleFeeSync();
        }

        return response;
      });
    };
  }

  function initSubscriptions() {
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, triggerSyncDebounced);
      log('subscribed via Dawn pubsub');
    }

    document.addEventListener('cart:refresh', triggerSyncDebounced);
    document.addEventListener('cart:updated', triggerSyncDebounced);
    document.addEventListener('cart:update', triggerSyncDebounced);
  }

  function initCheckoutGuard() {
    document.addEventListener(
      'click',
      async (event) => {
        if (!isCartPage()) return;

        const checkoutButton = event.target && event.target.closest('form[action="/cart"] [name="checkout"], button[name="checkout"]');
        if (!checkoutButton || checkoutSyncInProgress) return;

        checkoutSyncInProgress = true;
        event.preventDefault();

        try {
          const changed = await window.MSH_PersoFeeSync.runNow('before-checkout');
          if (changed) {
            await forceCartSectionsRerender('after-before-checkout-sync');
          }

          requestAnimationFrame(() => {
            checkoutButton.click();
          });
        } catch (error) {
          log('before-checkout sync failed', error);
          requestAnimationFrame(() => {
            checkoutButton.click();
          });
        } finally {
          setTimeout(() => {
            checkoutSyncInProgress = false;
          }, 0);
        }
      },
      true
    );
  }


  async function syncFeeQtyByNonceStable(maxPasses) {
    const passes = Number.isFinite(maxPasses) ? maxPasses : 3;
    if (window.__MSH_FEE_SYNC_RUNNING) return false;

    window.__MSH_FEE_SYNC_RUNNING = true;
    try {
      let changed = false;

      for (let pass = 0; pass < passes; pass += 1) {
        const cart = await fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' }).then((response) => response.json());
        const items = Array.isArray(cart && cart.items) ? cart.items : [];
        const mainsByNonce = new Map();

        items.forEach((item) => {
          const properties = item.properties || {};
          const nonce = String(properties[PROP_NONCE] || '').trim();
          const isFeeItem = properties[PROP_FEE_FLAG] === 'true' || properties[PROP_FEE_FLAG] === true;
          if (!isFeeItem && nonce) {
            mainsByNonce.set(nonce, toInt(item.quantity));
          }
        });

        const changes = [];
        items.forEach((item, index) => {
          const properties = item.properties || {};
          const nonce = String(properties[PROP_NONCE] || '').trim();
          const isFeeItem = properties[PROP_FEE_FLAG] === 'true' || properties[PROP_FEE_FLAG] === true;
          if (!isFeeItem) return;

          const desiredQty = nonce ? mainsByNonce.get(nonce) || 0 : 0;
          if (toInt(item.quantity) !== desiredQty) {
            changes.push({ line: index + 1, quantity: desiredQty });
          }
        });

        if (!changes.length) break;

        changed = true;
        window.__MSH_FEE_SYNC_INTERNAL = true;
        try {
          for (const change of changes) {
            const body = new URLSearchParams();
            body.set('line', String(change.line));
            body.set('quantity', String(change.quantity));
            await fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
              body,
            });
          }
        } finally {
          window.__MSH_FEE_SYNC_INTERNAL = false;
        }

        await new Promise((resolve) => setTimeout(resolve, 120));
      }

      return changed;
    } catch (error) {
      log('syncFeeQtyByNonceStable failed', error);
      return false;
    } finally {
      window.__MSH_FEE_SYNC_RUNNING = false;
    }
  }

  window.MSH_SyncPersoFeeByNonce = function MSH_SyncPersoFeeByNonce() {
    return runParentKeyAndQtySync('scheduled-sync');
  };

  window.MSH_ScheduleFeeSync = function MSH_ScheduleFeeSync() {
    clearTimeout(window.__MSH_FEE_SYNC_TIMER);
    window.__MSH_FEE_SYNC_TIMER = setTimeout(() => {
      runParentKeyAndQtySync('scheduled-sync').catch((error) => log('MSH_ScheduleFeeSync failed', error));
    }, 180);
  };

  if (DEBUG) {
    window.MSH_ClearCart = () => fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' }).then(() => location.reload());
  }

  window.MSH_PersoFeeSync.runNow = async function runNow() {
    if (window.MSH_SyncPersoFeeByNonce) {
      return window.MSH_SyncPersoFeeByNonce();
    }

    return false;
  };

  window.MSH_PersoFeeSync.runParentKeyAndQtySync = runParentKeyAndQtySync;

  document.addEventListener('DOMContentLoaded', () => {
    if (window.location.pathname === '/cart' && window.MSH_ScheduleFeeSync) {
      syncTriggerArmed = true;
      window.MSH_ScheduleFeeSync();
    }
  });

  initSubscriptions();
  patchFetch();
  initCheckoutGuard();
})();
